import { defineComponent as _defineComponent } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { UserDB } from '@/enitites/user'
import { ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import { useCloned } from '@vueuse/core'
import OnboardingFormLayout from './OnboardingFormLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingAvatarForm',
  props: {
    currentStep: { default: 0 },
    error: { default: '' },
    loading: { type: Boolean, default: false },
    steps: { default: 0 },
    user: null
  },
  emits: ["goBack", "submitForm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'goBack'): void
  (e: 'submitForm', value: UserDB): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentStep: number, error: string, loading: boolean, steps: number, user: UserDB };



const user = ref(useCloned(props.user).cloned)


const { saveImage } = useImage()
const avatarUrl = ref('/img/addImageProfile.svg')
const filesImgAvatar = ref<File | null>(null)
const inputRef = ref<HTMLInputElement | null>(null)

function openFileDialog() {
  inputRef.value?.click()
}

async function handlerFileChange(e: Event) {
  const target = e.target as HTMLInputElement
  filesImgAvatar.value = target.files ? target.files[0] : null
  if (!filesImgAvatar.value) return
  const reader = new FileReader()
  reader.onload = (event) => {
    avatarUrl.value = event.target?.result as string
  }
  reader.readAsDataURL(filesImgAvatar.value)

  user.value.avatar = await saveImage(filesImgAvatar.value)
}

return { __sfc: true,props, user, emit, saveImage, avatarUrl, filesImgAvatar, inputRef, openFileDialog, handlerFileChange, BKButton, OnboardingFormLayout }
}

})